module.exports = "https://la-static.prod-my.games/minigames/collection/img/card_row3_2.e4998df5.png";